import { render, staticRenderFns } from "./gradeHealth.vue?vue&type=template&id=6386ac55&scoped=true&"
import script from "./gradeHealth.vue?vue&type=script&lang=js&"
export * from "./gradeHealth.vue?vue&type=script&lang=js&"
import style0 from "./gradeHealth.vue?vue&type=style&index=0&id=6386ac55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6386ac55",
  null
  
)

export default component.exports